export default __webpack_public_path__ + "media/design-system/icon/assets/brand/SM/downside-9705b4bdf1243b8b1839c34ca0c5682c.svg";